import React from 'react';
import Notification from './Notification';
import { NOTIFICATION_AUTO_HIDE_MS } from '../constants/uiTiming';

interface NotificationWrapperProps {
  type: 'success' | 'error' | 'info';
  message: string;
  isVisible: boolean;
  onClose: () => void;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'center' | 'inline';
  targetElement?: HTMLElement | null;
  duration?: number;
}

const NotificationWrapper: React.FC<NotificationWrapperProps> = ({
  type,
  message,
  isVisible,
  onClose,
  position = 'top-right',
  targetElement,
  duration = NOTIFICATION_AUTO_HIDE_MS
}) => {
  return (
    <Notification
      type={type}
      message={message}
      isVisible={isVisible}
      onClose={onClose}
      position={position}
      targetElement={targetElement}
      duration={duration}
    />
  );
};

export default NotificationWrapper; 